import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ProductNotReturnableViewComponent } from '../../../../../product';
import { ItemPriceComponent, ItemStockButtonComponent } from '../../../../common';
import { RenderInItemResultLayoutDirective } from '../../../../layouts';
import { WireCutItemResultLayoutComponentsProviderComponentBase } from '../WireCutItemResultLayoutComponentsProviderComponentBase';
import { WireCutItemDescriptionComponent } from '../../wire-cut-item-description';

@Component({
  selector: 'ideal-wire-cut-item-result-layout-components-provider',
  imports: [
    RenderInItemResultLayoutDirective,
    ItemStockButtonComponent,
    ItemPriceComponent,
    WireCutItemDescriptionComponent,
    ProductNotReturnableViewComponent,
  ],
  standalone: true,
  templateUrl: './wire-cut-item-result-layout-components-provider.component.html',
  styleUrl: './wire-cut-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WireCutItemResultLayoutComponentsProviderComponent extends WireCutItemResultLayoutComponentsProviderComponentBase {
  protected readonly isCustomCut = computed(() => this.itemId()?.options.has('Z') ?? false);
}
